import React from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

const PhoneNumber = ({ value, onChange }) => {
	return (
		<PhoneInput
			placeholder="Enter phone number"
			country="US"
			countries={["US"]}
			className="custom-phone"
			defaultCountry="US"
			countrySelectProps={{ disabled: true }}
			value={value}
			onChange={onChange}
		/>
	);
};

export default PhoneNumber;
